<embed [src]="currentSrc" type="application/pdf" width="100%" height="100%" style="position: relative;"/>

<button class="btn btn-danger" (click)="closeDialog()" style="position: absolute; top: 4.2%; right: 1.5%; opacity: 0.9;">
    <i class="bi bi-x"></i>
</button>
